var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,63.7C14.5,63.7,0.3,49.5,0.3,32S14.5,0.3,32,0.3S63.7,14.4,63.7,32S49.5,63.7,32,63.7z M32,5.1 C17.1,5.1,5.1,17.1,5.1,32s12,26.9,26.9,26.9s26.9-12,26.9-26.9S46.9,5.1,32,5.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.9,46.6l-3-5c-0.2-0.2-0.5-0.2-0.7,0l-2,1.6l-5.1-7.6H32v-0.9h5.4c0.2,0,0.5-0.2,0.5-0.5v-4.9 c0-0.2-0.2-0.5-0.5-0.5h-1.6c-0.3,0-0.6,0-1,0c-0.9,0-2.1,0-2.9,0v-5.4c0-0.2-0.2-0.5-0.4-0.5h-7.3c-0.2,0-0.5,0.2-0.5,0.5v5.4 c-3,0.4-5.7,2-7.5,4.4c-1.9,2.5-2.6,5.6-1.9,8.7c0.8,4.1,4,7.3,8.1,8.3c3,0.7,6,0.1,8.5-1.6c2.5-1.7,4.2-4.5,4.7-7.4h0.1l5.4,8.2 l2,3.1c0,0.1,0.1,0.2,0.2,0.2h0.1c0.1,0,0.2,0,0.3-0.1l6.2-5.3c0.1-0.1,0.1-0.2,0.1-0.3C50,46.8,50,46.6,49.9,46.6z M28.7,41.3 c-0.7,1.6-2.2,2.7-3.9,2.7c-2.3,0-4.2-1.9-4.2-4.2c0-2,1.4-3.7,3.2-4.1v5.7L28.7,41.3L28.7,41.3z M24.4,33c-3.4,0.2-6,3.1-6,6.4 c0,3.6,2.9,6.4,6.5,6.4c3.2,0,5.9-2.3,6.4-5.6h2.1c-0.5,4.4-4.2,7.6-8.5,7.6c-4.8,0-8.6-3.9-8.6-8.5c0-4.5,3.7-8.2,8.1-8.4 C24.4,31.1,24.4,33,24.4,33z M30,38.8L30,38.8h-4l-0.1-13.6h3.6v4.9c0,0.2,0.1,0.4,0.3,0.6h0.1c0.3,0.2,0.5,0.3,5.7,0.2v1.3h-5.1 c-0.4,0-0.9,0.4-0.9,0.8v3.8c0,0.4,0.4,0.9,0.9,0.9h7.4l4.9,7.1l-1.1,1.1l-4.5-6.7c-0.2-0.2-0.5-0.3-0.8-0.3H30z M47.3,46.4 l-3.4,3l-1.1-1.8l3.4-3L47.3,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.7,21.5c2.8,0,5.2-2.4,5.2-5.2c0-2.9-2.3-5.2-5.2-5.2c-2.9,0-5.2,2.4-5.2,5.2C22.6,19.2,25,21.5,27.7,21.5 z M24.7,16.4c0-1.7,1.4-3,3.1-3s3,1.3,3.1,3c-0.1,1.7-1.4,3.1-3.1,3.1S24.7,18.1,24.7,16.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType29);
export default __webpack_public_path__ + "static/media/aioa-icon-type-29.a0d89bef8f5a957d132b33ae4d795ed0.svg";
export { ForwardRef as ReactComponent };